import { makeBaseSvgIconProps } from 'components/icons/_utils/makeBaseSvgIconProps'

export const IconDash = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 10 10')}>
      <path fill="currentColor" d="M 6.951 5.224 L 3.049 5.224 L 3.049 4.776 L 6.951 4.776 L 6.951 5.224 Z" />
    </svg>
  )
}
